import { useLocation } from 'react-router-dom';

import { addQueryParams, useRedirect } from '@main/core-ui';
import { isSombraScopeError } from '@main/sombra-types';

/**
 * Checks the error message to see if it is indicative of a Sombra scope error.
 *
 * If so, shows up the "no valid scope" modal.
 *
 * @returns The logout function
 */
export function useCheckSombraScopesError(): (error: string) => void {
  const location = useLocation();
  const redirect = useRedirect();

  return (error: string) => {
    if (isSombraScopeError(error)) {
      redirect(addQueryParams(location, { modal: 'no-valid-scope' }));
    }
  };
}
